
import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../context/AppContext";

function CardprojectComponent({ image, titre, objectif, budget, etat, id, path }) {
  const { apiUrlImg } = useAppContext();

  // Fonction pour couper  le texte
  const couperText = (text, maxWords) => {
    const words = text.split(" ");
    if (words.length > maxWords) {
      return `${words.slice(0, maxWords).join(" ")}...`;
    }
    return text;
  };

  const textEtat = `${etat === "EN_COURS"
      ? "En cours"
      : etat === "TERMINEE"
        ? "Terminé"
        : etat === "EST_DEMARRE"
          ? "Débuté"
          : etat === "A_FAIRE"
            ? "A faire"
            : ""
    }`;

  return (
    <div className="px-2 max-md:w-full max-lg:mb-2 mb-1 bg-transparent py-2 rounded-xl hover:bg-sky-100/20">
      <Link to={path}>
        <figure className="flex justify-center group relative h-[302px] max-lg:h-[220px]">
          <img
            src={`${apiUrlImg}/${image}`}
            alt="img"
            className="w-full h-full cursor-pointer rounded-md object-cover"
          />
        </figure>
      </Link>
      <div className="pt-4 grid gap-1">
        <div className="flex justify-between items-center">
          <div className="text-lg font-inter font-bold text-noirel">{titre}</div>
          <div className="text-xs font-inter text-orange">{budget} FCFA</div>
        </div>
        <p className="text-sm font-mandali text-grayrel">
          {couperText(objectif, 10)}{" "}
          {objectif.split(" ").length > 14 && (
            <Link to={path} className="text-orange hover:underline">
              Voir plus
            </Link>
          )}
        </p>
        <div className="flex justify-between items-center">
          <div
            className={`text-end text-xs ${etat === "EN_COURS"
                ? "text-orange"
                : etat === "TERMINEE"
                  ? "text-green-500"
                  : etat === "EST_DEMARRE"
                    ? "text-grys"
                    : "text-red"
              }`}
          >
            {textEtat}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardprojectComponent;
